import { CSSProperties, useCallback, useEffect, useState } from "react";

const getDotCount = (level: number) => {
    switch (level) {
        case 10: return 4;
        case 25: return 10;
        case 50: return 20;
        case 100: return 40;
        default: return 0;
    }
};

const generateDots = (count: number) =>
    Array.from({ length: count }).map((_, i) => ({
        left: `${Math.random() * 90}%`,
        top: `${Math.random() * 80}%`,
        key: `dot-${i}`,
    }));

const levels = [10, 25, 50, 100];

const TssDensityScale = ({ label }: { label: string }) => {
    const [expanded, setExpanded] = useState(true);
    return (
        <div
            onClick={() => setExpanded(true)}
            style={{
            display: 'flex',
            flexDirection: 'column',
            width: '90px',
            marginLeft: '100px',
            alignItems: 'center'
        }}>
            {/* Label */}
            <div style={{
                height: '30px',
                width: '70px',
                backgroundColor: expanded ? 'white' : 'black',
                color: expanded ? 'black' : 'white',
                fontWeight: 'bold',
                borderRadius: '20px',
                border: `2px solid black`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '10px',
                fontSize: '12px',
            }}>
                {label}
            </div>

            {/* Scale blocks */}
            { expanded && levels.map(level => {
                const dots = generateDots(getDotCount(level));

                return (
                    <div key={level} style={{
                        position: 'relative',
                        height: '25px',
                        width: '70px',
                        borderRadius: '12.5px',
                        backgroundColor: "#7FDCFF",
                        border: '1px solid #ccc',
                        marginBottom: '8px',
                        overflow: 'hidden',
                    }}>
                        {/* Particle dots */}
                        {dots.map(dot => (
                            <div key={dot.key} style={{
                                position: 'absolute',
                                width: '5px',
                                height: '5px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(139, 69, 19, 0.3)',
                                left: dot.left,
                                top: dot.top,
                            }} />
                        ))}

                        {/* Percentage label */}
                        <div style={{
                            position: 'absolute',
                            right: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            backgroundColor: 'white',
                            borderRadius: '12.5px',
                            border: '1px solid #ccc',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            height: '100%',
                            width: '25px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
                        }}>
                            {level}%
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TssDensityScale;
